<template>
  <div class="container">
    <van-nav-bar
      @click-left="onClickLeft"
      left-arrow
      title="电子健康卡管理"
      :fixed="true"
      class="header"
    >
      <template #right>
        <van-button type="info" size="small" @click="toAddCard"
          >+ 添加</van-button
        >
      </template>
    </van-nav-bar>
    <div class="list mt-header-nav">
      <DataList ref="dataList" api="Contact_List" :onLoadCallBack="onLoad">
        <template v-slot:item="item">
          <div class="card-item" @click="toInfo(item.obj)">
            <div class="card-content">
              <div class="title">广西壮族自治区卫生键康经员会</div>
              <div class="info">
                <div class="name">{{ item.obj.cardholderName }}</div>
                <div class="no">{{ item.obj.identityDocNo }}</div>
              </div>
              <div class="ewm">
                <div
                  v-if="item.obj.qrCodeText && item.obj.qrCodeText != '空'"
                  class="qrcode-wraper"
                >
                  <qrcode
                    :value="item.obj.qrCodeText"
                    :options="{ size: 90 }"
                  ></qrcode>
                  <img class="qrcode-image" src="/images/ybk-logo.png" />
                </div>
                <div v-else class="bind-button">
                  <van-button
                    @click.stop="onRegisterHealthCard(item.obj)"
                    size="mini"
                    >绑定电子健康卡</van-button
                  >
                </div>
              </div>
              <div class="text">
                中华人民共和国国家卫生健康委员会监制
              </div>
            </div>
          </div>
        </template>
      </DataList>

      <van-dialog
        v-model="showSelectAddType"
        :showConfirmButton="false"
        :showCancelButton="true"
        title="请选择添加方式"
      >
        <div class="type-list">
          <div class="type-item" @click="onAddTypeClick(1)">
            按姓名+身份证号绑卡
          </div>
          <div class="type-item" @click="onAddTypeClick(2)">
            按姓名+就诊卡号绑卡
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { Tag, Button, Icon, Card, Checkbox, Dialog, Toast, NavBar } from "vant";
import DataList from "@/components/DataList";
import { cache } from "@/utils/common";
import VueQrcode from "@xkeshi/vue-qrcode";

export default {
  name: "DoctorList",
  components: {
    DataList,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    [NavBar.name]: NavBar,
    [VueQrcode.name]: VueQrcode,
  },
  data() {
    return {
      currentContact: {},
      clickFlag: false,
      showSelectAddType: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.currentContact = cache.get("currentContact");
    },
    onLoad(res) {
      const data = res.data.datas;
      data.map(item => {
        if (item.isDefault) {
          cache.set("currentContact", item);
        }
      });
      // if (this.currentContact && this.currentContact.id) {
      //   const json = data.map((item) => {
      //     if (item.id === this.currentContact.id) {
      //       item.checked = true
      //     } else {
      //       item.checked = false
      //     }
      //     return item
      //   })
      //   return json
      // } else if (data.length) {
      //   cache.set("currentContact", data[0])
      // }
    },
    toInfo(item) {
      this.$router.push({
        name: "userContactInfo",
        query: {
          Id: item.id,
        },
      });
    },
    onClickLeft() {
      this.$router.push({ name: "user" });
    },
    // onAdd() {
    //   this.$router.push({ name: "userContactEdit" });
    // },
    onEdit(item) {
      this.$router.push({
        name: "userContactEdit",
        replace: true,
        query: {
          id: item.id,
        },
      });
    },
    onDel(item) {
      Dialog.confirm({
        message: "确认删除就诊人吗？",
      })
        .then(() => {
          this.$post("Contact_Del", { Id: item.id }).then(() => {
            //删除当前就诊人，清除缓存
            if (item.checked) {
              cache.remove("currentContact");
            }
            Toast.success("删除成功！");
            this.$refs.dataList.reload();
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    onRegisterHealthCard(item) {
      if (this.clickFlag == true) return;
      this.clickFlag = true;
      let json = {
        DiagnosisCardNo: item.cardNo,
        PatientName: item.cardholderName,
        MobilePhone: item.cardholderContactPhone,
        SexId: item.cardholderSex,
        Birthday: item.cardholderBirthDate,
        IdentityDocTypeDesc: item.identityDocTypeDesc,
        IdentityNo: item.identityDocNo,
        ContactAddress: item.cardholderContactAddress,
      };
      this.$post("Contact_RegisterHealthCard", json).then(res => {
        this.clickFlag = false;
        if (res.data.result) {
          Toast.success(res.data.message);
        } else {
          Toast.fail(res.data.message);
        }
      });
    },
    toAddCard() {
      // this.showSelectAddType = true;
      this.$router.push({
        name: "userContactCreatCardMenu",
      });
    },
    onAddTypeClick(type) {
      this.$router.push({
        name: "userContactEdit",
        query: {
          type,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-item {
  border: none;
  .value {
    line-height: 2rem;
    color: #333;
    font-size: 0.5rem;
  }
  .van-card__content {
    min-height: 1.6rem;
  }
}
// .type-list {
//   font-size: 14px;
//   padding: 20px;
//   .type-item {
//     padding: 20px;
//     border: 1px solid #ddd;
//     text-align: center;
//     margin-bottom: 10px;
//   }
// }
.list {
  padding: 16px;
  padding-bottom: 50px;
  /deep/.list-item {
    border: none;
  }
}
.card-item {
  width: 100%;
  height: 170px;
  background-image: url(/images/dzjkk.jpg);
  background-size: 100% 100%;
  margin-bottom: 20px;
  border-radius: 5px;
  position: relative;
  .card-content {
    padding: 10px;
    .title {
      margin-top: 5px;
      font-size: 12px;
    }
    .info {
      margin-top: 32px;
      .name {
        font-size: 20px;
        color: #333;
        margin-bottom: 10px;
      }
    }
    .ewm {
      position: absolute;
      right: 20px;
      bottom: 30px;
      width: 90px;
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
    }

    .text {
      position: absolute;
      bottom: 5px;
      text-align: center;
      font-size: 12px;
      width: calc(100% - 20px);
    }
  }
}
</style>
